import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReverseWaitListResponce } from "src/app/model/ReverseWaitListResponce";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RevertActivatedWaitlistConfigService } from "src/app/services/revert-activated-waitlist-config.service";
import { OprtdAppDtlsResponseModel } from "src/app/model/OprtdAppDtlsResponseModel";
import moment from "moment";

@Component({
  selector: "app-secure-view-wtlst-dtls-model",
  templateUrl: "./view-wtlst-dtls-model.component.html",
  styleUrls: ["./view-wtlst-dtls-model.component.scss"],
})
export class ViewWtlstDtlsModalComponent implements OnInit {
  @Input() reverseWaitListResponce: ReverseWaitListResponce;
  @Input() oprtdAppDtls: OprtdAppDtlsResponseModel;
  isLoading = false;
  pageMode: string = "";
  header: string;
  headerMode: string = "";
  isSubmitDisabled: boolean = false;
  isBtnDisable: boolean = false;
  isTimerStarted: boolean = false;
  form: FormGroup = new FormGroup({});
  selectedFile: File;
  base64: string | ArrayBuffer;
  fileType: string;
  timeLeft: number = 300; // 2 minutes in seconds
  isRegenerateOtp: boolean = false;
  timer: any;
  minDate: Date;
  currentDate: Date = new Date();
  isVisibleOtpText:boolean=false;
  isOprtdAppSurr: string;
  isOprtdAppAccPndng: string;
  isOprtdAppIneli: string;
  selectedWinStage: string;
  selectedApplType: string;
  @Output() dataModal = new EventEmitter<string>();

  constructor(
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private route: ActivatedRoute,
    private revertActivatedWaitlistConfigService: RevertActivatedWaitlistConfigService,
  ) {
    this.minDate = moment(this.currentDate).add("day").toDate();
  }

  ngOnInit(): void {

    this.form = new FormGroup({
      remarks: new FormControl(null),
      file: new FormControl(null),
      winStage: new FormControl(null),
      applType: new FormControl(null),
      otpValue: new FormControl(null,Validators.required),
    });
    
    console.log("reverseWaitListResponce >> ", this.reverseWaitListResponce);
    console.log("oprtdAppDtls >> ", this.oprtdAppDtls);
    
    this.isOprtdAppSurr = this.oprtdAppDtls.isOprtdAppSurr;
    this.isOprtdAppIneli = this.oprtdAppDtls.isOprtdAppIneli;
    this.isOprtdAppAccPndng = this.oprtdAppDtls.isOprtdAppAccPndng;

    this.headerMode = this.header;
    console.log("header >> ",this.headerMode);

  }

  onStageSelect(event: any){
    console.log("onStageSelect >> ", event);
    this.form.get('winStage').setValue(event);
    this.selectedWinStage = event;
  }

  onApplTypeSelect(event: any){
    console.log("onApplTypeSelect >> ", event);
    this.form.get('applType').setValue(event);
    this.selectedApplType = event;
  }

  onSubmit() {
    console.log("In Submit");

    // if(this.isOprtdAppSurr == "Y"){
    //   if(this.selectedWinStage == null || this.selectedWinStage == undefined){
    //     return this.showErrorToast("Please Select winner stage to revert application");
    //   }
    // }

    if(this.isOprtdAppIneli == "Y"){
      if(this.selectedApplType == null || this.selectedApplType == undefined){
        return this.showErrorToast("Please Select wether to allow applicant to make appeal request or not");
      }
    }

    if(this.base64 === null || this.base64 === undefined){
      return this.showErrorToast("Please Upload File");
    }

    if(this.form.value.remarks == null){
      return this.showErrorToast("Please provide Remark");
    }

    if(this.form.value.otpValue == null){
      return this.showErrorToast("Please provide OTP");
    }

    const data = [];
    data.push(this.form.value.remarks);
    data.push(this.base64);
    data.push(this.form.value.otpValue);
    data.push(this.oprtdAppDtls);
    
    if(this.isOprtdAppSurr == "Y"){
      data.push("OPRTD_APP_SURR");
      // data.push(this.selectedWinStage);
    }

    if(this.isOprtdAppIneli == "Y"){
      data.push("OPRTD_APP_INELI");
      data.push(this.selectedApplType);
    }

    console.log("Modal Data >> ", data);

    if(this.form.value.remarks != null && this.form.value.remarks !== undefined
      && this.base64 !== null && this.base64 !== undefined){
      return this.modalCtrl.dismiss(data, 'Submit');
    }
  }

  upload() {
    if (!this.selectedFile){
       this.showErrorToast("Please Upload the File");
    }
     
    if (!this.base64){
      this.showErrorToast("Please Upload the File");
    }

    if (this.base64) {
      return this.modalCtrl.dismiss(this.base64);
    }
    else {
      
    }
  }

  onFileSelect(event) {
    this.isSubmitDisabled = true;
    const file = event.target.files[0];
  
    const maxSize = 5 * 1024 * 1024;
  
    if (file && file.type === "application/pdf") {
      if (file.size <= maxSize) {
        this.selectedFile = file;
        console.log("Selected File in Modal >>>>> ", this.selectedFile);
  
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.base64 = reader.result;
          this.isSubmitDisabled = false;
        };
      } else {
        console.error("File size exceeds the limit of 5 MB.");
        this.isSubmitDisabled = false;
        alert("The selected file exceeds the size limit of 5 MB.");
      }
    } else {
      console.error("Invalid file type. Please select a PDF file.");
      this.isSubmitDisabled = false;
      alert("Invalid file type. Please select a PDF file.");
    }
  }
  
  

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  onCancel() {
    this.modalCtrl.dismiss();
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public space(event:any){
    if (event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  generateOtp(){
    console.log("generateOtp click >>");
    this.isRegenerateOtp = false;
    this.isBtnDisable = true;
    this.timeLeft = 300;

    if(this.isTimerStarted ===false){
      this.startTimer();
    }

    if(this.reverseWaitListResponce.oprtAppNo == null 
        || this.reverseWaitListResponce.oprtAppNo == undefined){
        this.isBtnDisable = false;
        return alert("Please Refresh and try again");
    }

    this.revertActivatedWaitlistConfigService.generateOtp(this.reverseWaitListResponce.oprtAppNo).subscribe(
      (data: any) => {
        if (data.status == "SUCCESS") {
          this.isBtnDisable = false;
          this.isVisibleOtpText=true;
        }
        if (data.status == "FAILURE") {
            this.isBtnDisable = false;
            alert(data.errorMessage);
        }
      }, 
      (error) => {
        this.isBtnDisable = false;
        alert("Invalid OTP");
      }
    );
  }

  startTimer() {
    this.isTimerStarted = true;
    this.timer = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        //disable
        this.isTimerStarted = true;
        this.isBtnDisable = true;
      } else {
        this.isRegenerateOtp = true;
        this.isTimerStarted = false;
        this.isBtnDisable = false;
        this.stopTimer();
      }
    }, 1000);
  }

  stopTimer() {
    this.isRegenerateOtp = true;
    clearInterval(this.timer);
  }

  get timerDisplay() {
    const minutes: number = Math.floor(this.timeLeft / 60);
    const seconds: number = this.timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
